export default __webpack_public_path__ + "3238f3faae69e31c7eec763acf9cb54c.png";